import { memo, useState } from "react";
import Name from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Name/Name";
import TitledHeadingText from "@coworker/apprestructured/src/task-management/components/TitledHeadingText/TitledHeadingText";
import { FixaInputField } from "@coworker/apprestructured/src/shared/wrappers/FixaInputField/FixaInputField";
import Actions from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Actions/Actions";
import Highlight from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Highlight/Highlight";
import Demo from "@coworker/apprestructured/src/task-management/demo/pages/ComponentDemoPage/demos/Demo/Demo";

function TitledHeadingTextDemo() {
  const [label, setLabel] = useState("Question");
  const [text, setText] = useState("How do I reset my password?");

  return (
    <Demo>
      <Name>TitledHeadingText</Name>
      <Highlight>
        <TitledHeadingText label={label} text={text} />
      </Highlight>
      <Actions>
        <FixaInputField
          label="label"
          type="text"
          id="titledheadingtextdemo-label"
          value={label}
          onChange={(e) => setLabel(e.target.value)}
        />
        <FixaInputField
          label="text"
          type="text"
          id="titledheadingtextdemo-text"
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
      </Actions>
    </Demo>
  );
}

export default memo(TitledHeadingTextDemo);
